import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled from 'styled-components';
import { setNoFocus } from '../../helpers/events-focus';
var InfoButton = styled.div(_templateObject());
var InfoButtonComponent = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var as = _ref.as,
      forwardedAs = _ref.forwardedAs,
      noFocus = _ref.noFocus,
      hasTouch = _ref.hasTouch,
      inactive = _ref.inactive,
      clickable = _ref.clickable,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "forwardedAs", "noFocus", "hasTouch", "inactive", "clickable"]);

  var href = props.href,
      onClick = props.onClick;
  var buttonAs = useMemo(function () {
    var componentAs = forwardedAs != null ? forwardedAs : as;

    if (!componentAs && href && !inactive) {
      componentAs = 'a';
    } else if (!componentAs && (onClick || clickable) && !inactive) {
      componentAs = 'button';
    } else if (!componentAs) {
      componentAs = 'div';
    }

    return componentAs;
  }, [forwardedAs, as, href, onClick, inactive, clickable]);
  return /*#__PURE__*/React.createElement(InfoButton, _extends({
    as: buttonAs,
    ref: forwardedRef
  }, props, setNoFocus(props, noFocus)));
});
export default InfoButtonComponent;